module.exports = __webpack_public_path__ + "img/mstar-logo.f726083c.png";